import React from "react";

const Service = () => {
  const services = [
    {
      icon: "fa-chalkboard-teacher",
      title: "Best Teachers",
      description:
        "Learn from experienced, passionate educators who are dedicated to helping students succeed and reach their full potential.",
    },
    {
      icon: "fa-book",
      title: "Book Library",
      description:
        "Access a rich and diverse collection of books, journals, and learning resources to support your academic, intellectual, and personal growth.",
    },
    {
      icon: "fa-laptop",
      title: "Online Courses",
      description:
        "Study anytime, anywhere with our flexible and interactive online courses designed to fit your schedule and learning pace.",
    },
    {
      icon: "fa-certificate",
      title: "Best Certificate",
      description:
        "Earn industry-recognized certificates that validate your knowledge and skills, helping you advance in your career or education.",
    },
    {
      icon: "fa-percent",
      title: "Best Discount",
      description:
        "Enjoy competitive pricing, seasonal offers, and exclusive discounts to make high-quality education more affordable, accessible, and rewarding for everyone.",
    },
    {
      icon: "fa-users",
      title: "Qualified Staff",
      description:
        "Our dedicated and qualified support staff are here to guide you every step of the way, ensuring a smooth learning experience.",
    },
  ];

  return (
    <div>
      {/* Inner Banner Section */}
      <div className="inner-banner py-5">
        <section className="w3l-breadcrumb text-left py-sm-5 ">
          <div className="container">
            <div className="w3breadcrumb-gids">
              <div className="w3breadcrumb-left text-left">
                <h2 className="inner-w3-title mt-sm-5 mt-4">Services</h2>
              </div>
              <div className="w3breadcrumb-right">
                <ul className="breadcrumbs-custom-path">
                  <li>
                    <a href="/Home">Home</a>
                  </li>
                  <li className="active">
                    <span className="fas fa-angle-double-right mx-2"></span>{" "}
                    Services
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Service Information Section */}
      <section className="w3l-passion-mid-sec py-5">
        <div className="container py-md-5 py-3">
          <div className="row w3l-passion-mid-grids">
            <div className="col-lg-6 w3hny-passion-item">
              <img
                src="assets/images/22.jpg"
                alt=""
                className="img-fluid radius-image"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "450px",
                }}
              />
            </div>
            <div className="col-lg-6 passion-grid-item-info ps-lg-5 mt-lg-0 mt-5">
              <h6 className="title-subw3hny mb-1">What We Do</h6>
              <h3 className="title-w3l mb-4">Personalized Experience</h3>
              <p className="mt-3 pe-lg-5">
                Every student is unique, and so is their learning journey. We
                tailor our programs, support, and resources to meet individual
                needs, helping each learner thrive at their own pace and style.
              </p>
              <ul className="icon-list-items mt-5">
                <li className="icon-list-item">
                  <i aria-hidden="true" className="fas fa-check"></i>
                  Excellent Teaching
                </li>
                <li className="icon-list-item ml-lg-4">
                  <i aria-hidden="true" className="fas fa-check"></i>
                  Comprehensive Curriculum
                </li>
                <li className="icon-list-item">
                  <i aria-hidden="true" className="fas fa-check"></i>
                  Extracurricular Activities
                </li>
                <li className="icon-list-item ml-lg-4">
                  <i aria-hidden="true" className="fas fa-check"></i>
                  Student Development & Counseling
                </li>
                <li className="icon-list-item ml-lg-4">
                  <i aria-hidden="true" className="fas fa-check"></i>
                  Quality Education Facilities
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="w3l-aboutblock1 grids-3-w3l py-5" id="services">
        <div className="container py-lg-5 py-md-4 py-2">
          <div className="title-content text-center mb-2">
            <h6 className="title-subw3hny mb-1">We Offer</h6>
            <h3 className="title-w3l">Our Services</h3>
          </div>
          <div className="row justify-content-center">
            {services.map((service, index) => (
              <div key={index} className="col-lg-4 col-md-6 grids-feature mt-5">
                <div className="area-box ser-1">
                  <div className="icon">
                    <i className={`fas ${service.icon} fa-3x`}></i>
                  </div>
                  <div className="area-box-info mt-2">
                    <h4>
                      <a href="#feature" className="title-head">
                        {service.title}
                      </a>
                    </h4>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;
